
const styles = (theme) => ({
  ...theme.global,
  box: {
    
  }
})
export default styles
